import SelectAreaContainer from '../containers/SelectAreaContainer'
import { BACKGROUND_SELECT_AREA } from 'constants/imageConstants'
import areaApi from 'api/Area'
import { useEffect, useState } from 'react'
import StorageKeys from 'constants/storage-keys'
import CommonUtils from 'utils/common'

const SelectAreaView = () => {
  const [areas, setAreas] = useState([])
  const areaId = localStorage.getItem(StorageKeys.AREA_ID)

  const getAreas = async () => {
    const res = await areaApi.getAreas({
      scope: 'business_select_area',
      only: ['id', 'country_code'],
    })
    setAreas(res.data)
  }

  useEffect(() => {
    if (areaId) {
      const lang = CommonUtils.getLanguage() || 'en'
      CommonUtils.goToNewLocation(`/?area_id=${areaId}&lang=${lang}`)
    }
    getAreas()
  }, [areaId])

  return (
    <SelectAreaContainer
      areas={areas}
      backgroundImage={BACKGROUND_SELECT_AREA}
      switchCountry={'/business/switch_area'}
    />
  )
}
export default SelectAreaView
